import React, { Fragment } from "react";
import ReturnHomeButton from "../../components/ReturnHomeButton";

const SectionReturnHome = () => {
  return (
    <Fragment>
      <div style={{ textAlign: "center" }}>
        <ReturnHomeButton />
      </div>
    </Fragment>
  );
};

export default SectionReturnHome;
